<template>
  <div class="printPage" style="height: 100%; padding-bottom: 30px">
    <div id="printPage">
      <div class="print-title">
        <!-- <img src="../../../../assets/img/orderDetail/print-title.png" /> -->
        <img :src="logoImg" />
      </div>
      <div class="print-line"></div>
      <div class="print-body">
        <div class="print-header">
          <div class="print-header-left">
            <div class="print-font">询比价采购方案</div>
          </div>
          <div v-if="isShowExport" class="print-header-right" @click="handleExportPdf">导出PDF</div>
        </div>

        <div class="print-base-info">
          <h1 class="base-info-title">基本信息</h1>
          <el-row>
            <el-col :span="12" class="base-info-item">
              <div class="label">询价单名称：</div>
              <div class="text">{{ detailInfo.enquiry.enquiryName }}</div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">询价类型：</div>
              <div class="text">
                {{
                  detailInfo.enquiry.enquiryType === 0
                    ? '定向询价'
                    : detailInfo.enquiry.enquiryType === 1
                    ? '公开询价'
                    : ''
                }}
              </div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">报价开始时间：</div>
              <div class="text">{{ detailInfo.enquiry.releaseTime }}</div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">报价截止时间：</div>
              <div class="text">{{ detailInfo.enquiry.quotationDeadline }}</div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">期望到货日期：</div>
              <div class="text">{{ detailInfo.enquiry.arrivalTime }}</div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">报价供应商数量：</div>
              <div class="text">
                {{ getOfferCounter() }}
              </div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">结算方式：</div>
              <div class="text">
                {{
                  detailInfo.enquiry.isDoC !== undefined
                    ? detailInfo.enquiry.isDoC === 1
                      ? '货到付款'
                      : '款到发货'
                    : ''
                }}
              </div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">配送方式：</div>
              <div class="text">
                {{ formatShipmentType(detailInfo.enquiry.shipmentType) }}
              </div>
            </el-col>
            <el-col :span="24" class="base-info-item">
              <div class="label">备注：</div>
              <div class="text">{{ detailInfo.enquiry.enquiryRemark }}</div>
            </el-col>
            <el-col :span="24" class="base-info-item">
              <div class="label">报价限额：</div>
              <div class="text">
                {{ detailInfo.enquiry.quotationLimit }}
                <span v-if="detailInfo.enquiry.quotationLimit">元(含税)</span>
              </div>
            </el-col>
            <el-col :span="12" class="base-info-item">
              <div class="label">采购总金额（元）：</div>
              <div class="text">¥{{ detailInfo.enquiry.totalAmount }}</div>
            </el-col>
          </el-row>
        </div>

        <div class="print-part-1">
          <div class="print-part-1-title">报价商品分配</div>
          <div class="table">
            <TableList
              :loading="loading"
              :table-data="detailInfo.supplierOfferList"
              :table-label="tableLabel"
              :index-show="true"
            ></TableList>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="product-info-wrapper">
          <div v-for="(item, index) in detailInfo.enquiryDetailList" :key="index" class="product-info-item">
            <h1 class="product-title">{{ `商品${index + 1}` }}</h1>
            <div class="product-info-desc">
              <el-row>
                <el-col :span="24" class="desc-item">
                  <div class="label">商品名称：</div>
                  <div class="text">{{ item.productName }}</div>
                </el-col>
                <el-col :span="12" class="desc-item">
                  <div class="label">规格型号：</div>
                  <div class="text">{{ item.specifications }}</div>
                </el-col>
                <el-col :span="12" class="desc-item">
                  <div class="label">品牌：</div>
                  <div class="text">{{ item.brandName }}</div>
                </el-col>
                <el-col :span="24" class="desc-item">
                  <div class="label">商品描述：</div>
                  <div class="text">{{ item.productDescription }}</div>
                </el-col>
                <el-col :span="12" class="desc-item">
                  <div class="label">历史最低价（元）：</div>
                  <div class="text">{{ item.minPrice }}</div>
                </el-col>
                <el-col :span="12" class="desc-item">
                  <div class="label">历史最高价（元）：</div>
                  <div class="text">{{ item.maxPrice }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="product-table">
              <TableList
                :loading="loading"
                :table-data="item.supplierOfferDetailList"
                :table-label="productTableLabel"
                :index-show="true"
              ></TableList>
            </div>
          </div>
        </div>

        <div class="remark-wrapper">
          <h1 class="remark-title">备注及附件</h1>
          <el-row>
            <el-col :span="24" class="remark-item">
              <div class="label">备注：</div>
              <div class="text">
                {{ detailInfo.enquiry.selectivePricingRemark }}
              </div>
            </el-col>
            <el-col :span="24" class="remark-item">
              <div class="label">附件：</div>
              <div class="text">
                <span
                  v-for="(item, index) in detailInfo.enquiry.selectivePricingAttachmentList"
                  :key="index"
                  class="file-name"
                >
                  {{ item.attachmentName }}
                </span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="last-table-wrapper">
          <h1 class="main-title">审批记录</h1>
          <!-- v-if="initiateList.length > 0" -->
          <div>
            <div class="sub-title">发起询价审批记录</div>
            <div class="table">
              <TableList :loading="loading" :table-data="initiateList" :table-label="recordLabel" :index-show="true">
                <template #auditStatus="{ scope }">
                  <span>{{ auditStatus[scope.row.auditStatus] }}</span>
                </template>
              </TableList>
            </div>
          </div>
          <!-- v-if="chooseList.length > 0" -->
          <div>
            <div class="sub-title">选商定价审批记录</div>
            <div class="table">
              <TableList :loading="loading" :table-data="chooseList" :table-label="recordLabel" :index-show="true">
                <template #auditStatus="{ scope }">
                  <span>{{ auditStatus[scope.row.auditStatus] }}</span>
                </template>
              </TableList>
            </div>
          </div>
          <!-- v-if="detailInfo.enquiryOfferChangeList.length > 0" -->
          <div>
            <div class="sub-title">延时记录</div>
            <div class="table">
              <TableList
                :loading="loading"
                :table-data="detailInfo.enquiryOfferChangeList"
                :table-label="delayLabel"
                :index-show="true"
              ></TableList>
            </div>
          </div>
        </div>

        <div class="bottom-wrapper">
          <div class="bottom-right">
            <div class="bottom-item">
              <div class="label">采购商名称：</div>
              <div class="text">{{ detailInfo.enquiry.purchaseCompany }}</div>
            </div>
            <div class="bottom-item">
              <div class="label">制单人：</div>
              <div class="text">{{ detailInfo.enquiry.editMemberName }}</div>
            </div>
            <div class="bottom-item">
              <div class="label">制单日期：</div>
              <div class="text">{{ detailInfo.enquiry.editTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="print-part-4">
      <div v-if="isShowExport" class="print-part-close" @click="handleClose">关闭</div>
      <div v-if="isShowExport" class="print-part-pdf" @click="handleExportPdf">导出PDF</div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry/index';
import cmsOssApi from '@/modules/projectA/api/cms-oss/index.js';
import TableList from '../../components/common/e-table-list';
// import WaterMark from '../utils/waterMark';
import utils from '../../utils/utils';

export default {
  name: 'EnquiryOption',
  components: {
    TableList,
  },
  props: {},
  data() {
    return {
      detailInfo: {
        enquiry: {},
        enquiryDetailList: [],
        supplierOfferList: [],
        enquiryOfferChangeList: [],
      },
      enquiryAttachment: { attachmentName: '' },

      loading: false,
      tableLabel: [
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'center',
          width: '320',
        },
        {
          label: '分配总金额（元）',
          param: 'allocationAmount',
          align: 'center',
          width: '160',
        },
        {
          label: '分配总数量',
          param: 'allocationQuantity',
          align: 'center',
          width: '160',
        },
        {
          label: '报价总价（元）',
          param: 'offerAmount',
          align: 'center',
          width: '160',
        },
        {
          label: '总运费（元）',
          param: 'deliveryFee',
          align: 'center',
          width: '160',
        },
        {
          label: '易派客标准指数',
          param: 'scoreAll',
          align: 'center',
        },
      ],
      query: {
        orderId: null,
        purchaseCompanyId: null,
      },
      tableData: [],
      upperPrice: '',
      upperShipping: '',
      logo: require('../../../../assets/img/common/epec.png'),
      isShowExport: true,

      productTableLabel: [
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'center',
          width: '260',
        },
        {
          label: '需求数量',
          param: 'quantity',
          align: 'center',
          width: '100',
        },
        {
          label: '计量单位',
          param: 'unitName',
          align: 'center',
          width: '100',
        },
        {
          label: '报价单价（含税）',
          param: 'price',
          align: 'center',
        },
        {
          label: '税率（%）',
          param: 'taxRate',
          align: 'center',
        },
        {
          label: '运费（元）',
          param: 'deliveryFee',
          align: 'center',
        },
        {
          label: '小计（元）',
          param: 'totalPrice',
          align: 'center',
        },
        {
          label: '备注',
          param: 'attachmentRemark',
          align: 'center',
        },
        /* {
          label: '金额(含税)',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
        }, */
      ],
      recordLabel: [
        {
          label: '审批层级',
          param: 'auditNode',
          align: 'center',
        },
        {
          label: '审批人',
          param: 'auditMemberName',
          align: 'center',
        },
        {
          label: '审批时间',
          param: 'updateTime',
          align: 'center',
          width: '260',
        },
        {
          label: '审批状态',
          param: 'auditStatus',
          align: 'center',
          slot: 'auditStatus',
        },
        {
          label: '审批意见',
          param: 'auditRemark',
          align: 'center',
        },
      ],
      auditStatus: { 0: '待审批', 1: '审批通过', 2: '审批拒绝' },
      delayLabel: [
        {
          label: '操作人',
          param: 'createMemberName',
          align: 'center',
        },
        {
          label: '延时发起时间',
          param: 'createTime',
          align: 'center',
          width: '280',
        },
        {
          label: '报价截止时间',
          param: 'quotationDeadlineStr',
          align: 'center',
          width: '280',
        },
        {
          label: '延时原因',
          param: 'remark',
          align: 'center',
        },
      ],
      companyId: '',
      initiateList: [],
      chooseList: [],
      logoImg: require('@/assets/img/orderDetail/print-title.png'),
    };
  },
  mounted() {
    const { companyId } = this.$store.state.USERINFO;
    this.getAuditData(companyId);
    this.getChooseData(companyId);
    this.getDetailInfo();
    const { purchaseAreaCompanyId } = this.$store.state.USERINFO;
    if (process.env.NODE_ENV === 'production') {
      if (purchaseAreaCompanyId === 9506269) {
        this.logoImg = require('@/assets/img/orderDetail/cg.png');
      }
    } else if (purchaseAreaCompanyId === 136641) {
      // this.logoImg = 'https://www.baidu.com/img/flexible/logo/pc/result.png';
      // this.logoImg = require('@/assets/img/orderDetail/print-title.png');
      this.logoImg = require('@/assets/img/orderDetail/cg.png');
    }
  },
  created() {},
  methods: {
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
    getOfferCounter() {
      if (this.detailInfo.enquiry.enquiryType === 1) {
        return this.detailInfo.enquiry.quotationCount === 0 ? 0 : this.detailInfo.enquiry.quotationCount;
      }
      // 定向询价
      return this.detailInfo.enquiry.quotationCount === 0
        ? `${0}/${this.detailInfo.enquiry.offerCount}`
        : `${this.detailInfo.enquiry.quotationCount}/${this.detailInfo.enquiry.offerCount}`;
    },
    async getDetailInfo() {
      const result = await Api.purchasePlan({
        enquiryId: this.$route.query.enquiryId,
      });
      if (result.code === '200') {
        result.data.enquiryOfferChangeList.forEach((el) => {
          el.quotationDeadlineStr = JSON.parse(el.changeDataJson).quotationDeadlineStr;
        });
        this.detailInfo = { ...result.data };
        const { enquiryAttachmentList = [] } = result.data.enquiry;
        console.log(this.detailInfo, ' this.detailInfo ');
      }
    },
    // usinessAuditType 5为发起询价审批记录，6为选商定价审批记录
    async getAuditData(companyId) {
      const result = await Api.queryAuditBusinessFlowLogList({
        companyId,
        businessId: this.$route.query.enquiryId,
        businessAuditType: 5,
      });
      result.data.forEach((item) => {
        item.nodeMember.auditNode = item.auditNode;
      });
      if (result.code === '200') {
        this.initiateList = result.data.map((el) => el.nodeMember);
      }
    },
    async getChooseData(companyId) {
      const result = await Api.queryAuditBusinessFlowLogList({
        companyId,
        businessId: this.$route.query.enquiryId,
        businessAuditType: 6,
      });
      if (result.code === '200') {
        result.data.forEach((item) => {
          item.nodeMember.auditNode = item.auditNode;
        });
        this.chooseList = result.data.map((el) => el.nodeMember);
      }
    },
    handleClose() {
      window.close();
    },
    handleExportPdf() {
      this.isShowExport = false;
      setTimeout(() => {
        this.getPdf('printPage');
      }, 0);
      setTimeout(() => {
        this.isShowExport = true;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.printPage {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
}
.printPage {
  padding-bottom: 30px;
  background: url('../../../../assets/img/common/bk-epk.png') repeat;
}
.print-title {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  line-height: 80px;
  img {
    width: 343px;
    height: 54px;
  }
}
.print-line {
  border: 1px solid #000000;
}
.print-body {
  width: 1200px;
  margin: 0 auto;
  .print-header {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .print-header-left {
      border-left: 6px solid #2587ff;
      height: 28px;
      .print-font {
        font-size: 28px;
        color: #333333;
        line-height: 28px;
        margin-left: 10px;
      }
    }
    .print-header-right {
      color: #ffffff;
      width: 75px;
      height: 30px;
      background: #2587ff;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .remark-wrapper {
    padding: 20px 0 10px 0;
    border-bottom: 2px solid #d9d9d9;
    .remark-title {
      color: #333;
      font-size: 16px;
      line-height: 1;
      padding-bottom: 20px;
    }
    .remark-item {
      margin-bottom: 20px;
      display: flex;
      font-size: 14px;
      color: #333;
      line-height: 1;
      .label {
        flex-shrink: 0;
        width: 100px;
        text-align: right;
      }
      .text {
        .file-name {
          margin-right: 20px;
        }
      }
    }
  }
  .print-base-info {
    width: 1200px;
    /*     height: 118px; */
    border-bottom: 2px solid #d9d9d9;
    .base-info-title {
      color: #333;
      font-size: 16px;
      line-height: 1;
      padding-bottom: 20px;
    }
    .base-info-item {
      margin-bottom: 20px;
      display: flex;
      font-size: 14px;
      color: #333;
      line-height: 1;
      .label {
        flex-shrink: 0;
        width: 130px;
        text-align: right;
      }
      &:last-child {
        .label {
          font-weight: bold;
        }
        .text {
          color: #f0250f;
        }
      }
    }
  }
  .print-part-1 {
    display: flex;
    flex-direction: column;

    .print-part-1-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      padding: 30px 0 20px 0;
      font-size: 16px;
      color: #333333;
    }
    .print-total {
      height: 68px;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      div:nth-child(1) {
        display: flex;
        margin-left: 10px;
        div:nth-child(1) {
          width: 85px;
          display: flex;
          justify-content: flex-end;
          font-size: 16px;
          line-height: 16px;
          color: #333333;
        }
        div:nth-child(2) {
          font-size: 16px;
          line-height: 16px;

          color: #f0250f;
        }
        div:nth-child(3) {
          font-size: 16px;
          line-height: 16px;

          color: #333333;
        }
      }
      div:nth-child(2) {
        display: flex;
        margin-left: 10px;
        div:nth-child(1) {
          width: 85px;
          display: flex;
          justify-content: flex-end;
          font-size: 16px;
          line-height: 16px;
          color: #333333;
        }
        div:nth-child(2) {
          font-size: 16px;
          line-height: 16px;

          color: #f0250f;
        }
        div:nth-child(3) {
          font-size: 16px;
          line-height: 16px;

          color: #333333;
        }
      }
    }
  }
  .product-info-wrapper {
    padding-bottom: 30px;
    border-bottom: 2px solid #d9d9d9;
    .product-info-item {
      .product-title {
        color: #333;
        font-size: 16px;
        line-height: 1;
        padding: 30px 0 20px 0;
      }
      .product-info-desc {
        .desc-item {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          line-height: 1;
          .label {
            width: 150px;
            text-align: right;
          }
        }
      }
    }
  }

  .last-table-wrapper {
    margin-top: 30px;
    .main-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    .sub-title {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      line-height: 1;
      padding: 20px 0;
    }
  }

  .bottom-wrapper {
    padding: 15px;
    margin-top: 30px;
    background: #e8efff;
    display: flex;
    justify-content: flex-end;
    .bottom-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 88px;
      color: #333;
      .bottom-item {
        display: flex;
        font-size: 16px;
        font-weight: bold;
        line-height: 1;
        .label {
          width: 120px;
          text-align: right;
        }
      }
    }
  }
}
.table {
  ::v-deep .el-table {
    background-color: transparent;
  }
  ::v-deep .el-table tr {
    background-color: transparent;
  }
}
.print-part-4 {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .print-part-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 30px;

    background: #ffffff;
    border: 1px solid #c5c5c5;
    color: #333333;
    font-size: 14px;
    margin-right: 30px;
    cursor: pointer;
  }
  .print-part-pdf {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 30px;

    background: #2587ff;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
